import React from "react";
import {
	BooleanInput,
	Datagrid,
	EditButton,
	Filter,
	List,
	TextField,
	TextInput,
	ShowButton,
	DeleteButton,
	usePermissions,
} from "react-admin";

import { userPreferences } from "../../utils/fakeUserPrefrences";
import { constants, rolesGlobal } from "../../utils/constants";
import { CustomBooleanInput } from "../../customComponents/CustomBooleanInput";

const JournalFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
		<BooleanInput source="isActive" defaultValue={true} />
	</Filter>
);

const ReadOnlyOrToggleField = ({ source, disabled, record, ...rest }) => {
    const inputValue = record ? record[source] : false;

    if (disabled) {
        return (
            <span style={{
                padding: '4px 8px',
                borderRadius: 4,
                fontSize: '0.85rem',
                fontWeight: 'bold',
                backgroundColor: inputValue ? '#e8f5e9' : '#ffebee',
                color: inputValue ? '#2e7d32' : '#c62828',
                display: 'inline-block'
            }}>
                {inputValue ? "Active" : "Inactive"}
            </span>
        );
    }

    return <CustomBooleanInput source={source} record={record} disabled={false} {...rest} />;
};

export const JournalList = (props) => {
	const { permissions, isLoading } = usePermissions();

	if (isLoading) return null;
	const userRoles = Array.isArray(permissions) ? permissions : (permissions ? [permissions] : []);
    const isCoach = userRoles.includes(rolesGlobal.coach);
    const hideActions = isCoach || userRoles.length === 0;
	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<JournalFilter />}
			exporter={false}
		>
			<Datagrid>
				<TextField
					source={`name.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<ReadOnlyOrToggleField source="isActive" sortable={false} disabled={hideActions} />
				<ShowButton />
				{hideActions === false && <EditButton />}
				{hideActions === false && <DeleteButton mutationMode="pessimistic" />}
			</Datagrid>
		</List>
	);
};

export default JournalList;
